// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__lqUW2","Logo":"Toolbar_Logo__R4lJD","DesktopOnly":"Toolbar_DesktopOnly__Tw6ei"};